/**
 * Componente MotionWrapper
 * Wrapper reutilizable para secciones con transiciones de framer-motion
 */
import React from "react";
import { motion } from "framer-motion";

const MotionWrapper = ({
    children,
    sectionKey,
    className = "absolute inset-0 flex flex-col items-center justify-center text-center bg-black bg-opacity-90",
    initial = { opacity: 0 },
    animate = { opacity: 1 },
    exit = { opacity: 0 },
    transition = { duration: 0.8 },
    style = {},
}) => {
    return (
        <motion.div
            key={sectionKey}
            className={className}
            initial={initial}
            animate={animate}
            exit={exit}
            transition={transition}
            style={style}
        >
            {children}
        </motion.div>
    );
};

export default MotionWrapper;
